module.exports = __webpack_public_path__ + "static/media/manfred-nigel.902ce295.png";